<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
  
    <div *ngIf="assetsData.length > 0">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12" *ngFor="let item of assetsData">
          <div class="remove_business_photo" *ngIf="item.imgUrl" ><button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            class="profile_button"
            class="share"
          >
            <mat-icon class="material-icons-outlined"
              >more_vert</mat-icon
            >
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="setDefaultImage(item)">
              <mat-icon class="material-icons-outlined">wallpaper</mat-icon>
              <span class="menu_text">Set as default</span>
            </button>
            <button mat-menu-item (click)="deleteImage(item)">
              <mat-icon class="material-icons-outlined"
                >delete</mat-icon
              >
              <span class="menu_text">{{
                "business_details.delete" | translate
              }}</span>
            </button>
          </mat-menu></div>
          <div class="gallery_img_div" *ngIf="item.mediaType == 'image'">
            <img [src]="item.imageThumbUrl" alt="" class="gallery_img">
          </div>
          <div class="gallery_img_div" *ngIf="item.mediaType == 'video'">
            <video controls class="gallery_img_vid">
              <source [src]="item.imgUrl" type="video/mp4">
            </video>
          </div>
  
        </div>
        <!-- <div class="col-sm-12 col-md-6 col-lg-6">
          <video  width="300" controls>
            <source src="https://storage.googleapis.com/salon-market_entity_videos/time_stamp_1693411055969_VID_2023-08-30 09-27-24865168823.mp4" type="video/mp4" />
        </video>
        </div> -->
      </div>
    </div>
  
    <div *ngIf="assetsData.length == 0">
      <div class="row" style="text-align: center;margin: 30px 0px;">
        <p>There are no images to show.</p>
      </div>
    </div>
  
  </mat-dialog-content>
  
  <!-- <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !serviceListData.serviceName ||
        !serviceListData.description ||
        !serviceListData.approxTime
      "
      (click)="onPost()"
    >
      {{ editMode ? "Edit" : "Save" }}
    </button>
  </mat-dialog-actions> -->
  